import { 
  APP_CHANGE_THEME
} from '../actions/app.actions'

const initState = {
  theme: 'ligth'
}

const appReducer = (state = initState, action) => {
  const { type, payload } = action
  const newState = { ...state }
  
  switch (type) {
    case APP_CHANGE_THEME: 
      newState.theme = payload.theme
    break             
    default:
    break
  }

  return newState
}

export default appReducer
